import React, { Component } from "react";
import { Button } from "reactstrap";
import style from "./MedicalNotes.module.css";
import api from "../../utils/Api";
import history from "../../utils/history";
import ttmLoader from "../../assets/images/ttm-loader.gif";
import {
    fetchpractitioner,
    fetchpatient,
    saveMedicalNotes,
    fetchExternalPractitionerAutoComp
  } from "../../redux";
import { connect } from "react-redux";
import { Select } from "antd";
import {AppointmentNotesSection} from "../AppoinmentCreation/AppointmentNotesSection";
const { Option } = Select;

export class MedicalNotes extends Component {
    constructor(props) {
        super(props);

        this.state = {
            createNoteserror: "",
            isLoading: false,
            successMsg: "",
            errorMsg: "",
            patient_id: "",
            patient_name: "",
            practitioner_id: "",
            practitioner_name: "",
            notesList: [],
            notesTypes: "1",
            notesText: "",
            isRefNote: "",
            ref_doctor_id: "",
            ref_doctor_name: "",
            ref_doctor_email: "",
            ref_doctor_address: "",
            emailError: "",
            docTypeBtnLabel: "Create",
            isFormValid: false,
            isError: "",
            createNotes: { document_type: "", document_note: "" },
            isScreenLoaded: false,
            practice_logo: "",
            patientDetail: {},
            practitionerDetail: {},
            attachedDocuments: [],
        };

    }
  componentDidMount = async () => {
      
    document.title = 'Medical Notes - TechToMedix';
    await this.props.fetchpractitioner(this.state.practitioner_name);
    await this.props.fetchpatient(this.state.patient_name);
    await this.props.fetchExternalPractitionerAutoComp("");

    let userInfo = JSON.parse(localStorage.getItem("USER_INFO"));
    if(userInfo && userInfo.systemRole === 2 && userInfo.contact_id){
        this.setState({
            practitioner_id: userInfo.contact_id,
            practitioner_name: userInfo.contact_id,
        })
    }


    setTimeout(() => {
        this.setState({
          isScreenLoaded: true,
        });
      }, 500);
  }
 

  onSearchPatient = (val) => {
    // console.log("Patient search:", val);
     this.setState({
       patient_name: val,
     });
     // calling patient autocomplete data
     this.props.fetchpatient(val);
   };

  onChangePatient = (value) => {
    // console.log(`selected ${value}`);
     this.setState({
       patient_name: value,
       patient_id: value,
     },()=>{
      this.emptyAttachteddocuments();
    });
   };
 
   onChangePratitioner = (value) => {
    // console.log(`selected ${value}`);
     this.setState({
       practitioner_name: value,
       practitioner_id: value,
     },()=>{
       this.emptyAttachteddocuments();
     });
   };

   onSearchPratitioner = (val) => {
    // Calling practitioner autocomplete data
    this.props.fetchpractitioner(val);
    this.setState({
      practitioner_name: val,
    });
  };

  emptyAttachteddocuments = () => {
    this.setState({
      attachedDocuments: [],
      practice_logo: "",
      patientDetail: {},
      practitionerDetail: {}
    })
  }

  handleInputChangeTypes = (e) => {
    const { name, value } = e.target;
    this.setState({
        notesTypes: value
    })
    if (value === "2") {
        this.setState({
            isRefNote: true
        })
    } else {
        this.setState({
            isRefNote: false
        })
    }
    
    this.setState({
        docTypeBtnLabel: "Create",
        notesText: "",
        ref_doctor_id: "",
        ref_doctor_name: "",
        ref_doctor_email: "",
        ref_doctor_address: "",
    });
  };


  clearNotes = () => {
    this.setState({
      notesList: [],
      notesTypes: "1",
      notesText: "",
      isRefNote: "",
      ref_doctor_id: "",
      ref_doctor_name: "",
      ref_doctor_email: "",
      ref_doctor_address: "",
      emailError: "",
      docTypeBtnLabel: "Create",
      isFormValid: false,
      isError: "",
      createNotes: { document_type: "", document_note: "" },
    })
  }


  handleInputRef = (e) => {
    const { name, value } = e.target;
    this.setState({
        [name]: value
    },()=>{
        if(name === "ref_doctor_email"){
            this.validateEmail(value)
        }
    this.removeError();
    });
  };

  handleInputRefDoctorName = (value, name) => {
    const practitionerObj = this.props.externalPractitionersAutoCompData &&
                this.props.externalPractitionersAutoCompData.externalPractitionersAutoComp &&
                this.props.externalPractitionersAutoCompData.externalPractitionersAutoComp.find((element, index) => {
                    return element.practitioner_id === value;
                });
    this.setState({
        ref_doctor_name: practitionerObj && practitionerObj.practitioner_name ? practitionerObj.practitioner_name : "",
        ref_doctor_id: value,
        ref_doctor_email: practitionerObj && practitionerObj.email ? practitionerObj.email : "",
        ref_doctor_address: practitionerObj && practitionerObj.physical_address ? practitionerObj.physical_address : "",
    }, () => {
        this.removeError();
    })
};

  handleInputChangeNotes = (e) => {
    const { name, value } = e.target;
    this.setState({
        notesText: value
    },()=>{
     this.removeError();
    })
  };

  validateEmail = (email) => {
    const pattern = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    const result = pattern.test(email);
    if (result === true) {
        this.setState({
            emailError: false
        })
    } else {
      
        this.setState({
            emailError: true
        })
    }
  };

  // Created notes array
  noteAdd = () => {
    if (
      this.state.notesText === ""
    ) {
        this.setState({
            createNoteserror: "Please filled out mandatory filled"
        })
    } else if (
      (this.state.isRefNote && this.state.ref_doctor_id === "") ||
      (this.state.isRefNote && this.state.ref_doctor_name === "") ||
      (this.state.isRefNote && this.state.ref_doctor_email === "") ||
      (this.state.isRefNote && this.state.ref_doctor_address === "") ||
      (this.state.isRefNote && this.state.emailError === true)
    ) {
        this.setState({
            createNoteserror: "Please filled out mandatory filled"
        })    
    } else {
      const notesListData = [...this.state.notesList];
      const exist = notesListData.findIndex((element) => {
        return element.notesTypes === this.state.notesTypes;
      });
      if (exist === -1 && this.state.docTypeBtnLabel === "Create") {
        if (this.state.isRefNote) {
          notesListData.push({
            notesTypes: this.state.notesTypes,
            notesText: this.state.notesText,
            ref_doctor_id: this.state.ref_doctor_id,
            ref_doctor_name: this.state.ref_doctor_name,
            ref_doctor_email: this.state.ref_doctor_email,
            ref_doctor_address: this.state.ref_doctor_address,
          });
          // reset after push data into array
          this.setState({
            notesText: "",
            notesTypes: "1",
            ref_doctor_id: "",
            ref_doctor_name: "",
            ref_doctor_email: "",
            ref_doctor_address: "",
            isRefNote: false
        })
        } else {
          notesListData.push({ 
              notesTypes: this.state.notesTypes, 
              notesText: this.state.notesText 
            });
          // reset after push data into array
          this.setState({
            notesText: "",
            notesTypes: "1",
        })
        }
      } else if(exist > -1 && this.state.docTypeBtnLabel === "Update") {
        // notesListData[exist] = { notesTypes, notesText };
        if (this.state.isRefNote) {
          notesListData[exist] = {
            notesTypes: this.state.notesTypes,
            notesText: this.state.notesText,
            ref_doctor_id: this.state.ref_doctor_id,
            ref_doctor_name: this.state.ref_doctor_name,
            ref_doctor_email: this.state.ref_doctor_email,
            ref_doctor_address: this.state.ref_doctor_address,
          };
        } else {
          notesListData[exist] = { 
            notesTypes: this.state.notesTypes, 
            notesText: this.state.notesText 
        };
        }
      }else if(exist > -1 && this.state.docTypeBtnLabel === "Create"){
        this.setState({
            createNoteserror: "You cannot create more than one note of each type."
        })

        setTimeout(() => {
            this.setState({
                createNoteserror: ""
            })
        }, 2500);
        return false;
      }
      this.setState({
        notesList: notesListData
    })
      console.log("After notes obj add", this.state.notesList);
    }
  };


  removeError = () => {
    if (!this.state.isRefNote) {
      if (this.state.notesText !== "") {
        this.setState({
            createNoteserror: ""
        })
      }
    } else {
      if (
        this.state.notesText !== "" &&
        this.state.ref_doctor_id !== "" &&
        this.state.ref_doctor_name !== "" &&
        this.state.ref_doctor_email !== "" &&
        this.state.ref_doctor_address !== ""
      ) {
        this.setState({
            createNoteserror: ""
        })
      }
    }
  };

  // Edit notes array
  onEditClick = (index, notesTypes) => {
    this.setState({
        docTypeBtnLabel: "Update"
    })
    if (notesTypes === "2") {
        this.setState({
        isRefNote: true
        })
    } else {
        this.setState({
            isRefNote: false
        })
    }
    this.setState({
        notesText: this.state.notesList[index].notesText,
        notesTypes: this.state.notesList[index].notesTypes,
        ref_doctor_id: this.state.notesList[index].ref_doctor_id,
        ref_doctor_name: this.state.notesList[index].ref_doctor_name,
        ref_doctor_email: this.state.notesList[index].ref_doctor_email,
        ref_doctor_address: this.state.notesList[index].ref_doctor_address,
        createNoteserror: ""
    })
  };

  // Edit notes array
//   onUpdate = () => {
//     setNotesTypes(notesList[0].notesTypes);
//     setNotesText(notesList[0].notesText);
//     setRefDoctorName(notesList[0].ref_doctor_name);
//     setRefDoctorEmail(notesList[0].ref_doctor_email);
//     setRefDoctorAddress(notesList[0].ref_doctor_address);
//   };

  handleRemoveNoteClick = (index) => {
    const notesListData = [...this.state.notesList];
    notesListData.splice(index, 1);
    this.setState({
        notesText: "",
        notesTypes: "1",
        ref_doctor_id: "",
        ref_doctor_name: "",
        ref_doctor_email: "",
        ref_doctor_address: "",
        isRefNote: false,
        notesList: notesListData,
        createNoteserror: "",
        docTypeBtnLabel: "Create"
    })
  };



  // Validations for diagonsis
  onSubmit = async () => {
    
      if (this.state.createNoteserror || !this.state.patient_id || !this.state.practitioner_id || this.state.notesList.length === 0 ) {
          this.setState({
              isError: "Please filled out all mandatory fields",
              isFormvalid: false
          })
      } else {
        this.setState({
            isError: "",
            isFormvalid: true,
            isLoading: true
        })

          const doctorNotesData = this.state.notesList.map((item) => ({
            notes: item.notesText,
            lk_document_type_id: item.notesTypes,
            referring_practioner_id: item.ref_doctor_id,
            referred_doctor_name: item.ref_doctor_name,
            referred_doctor_email: item.ref_doctor_email,
            referred_doctor_address: item.ref_doctor_address,
          }));


          const payload = {
            associated_related_party_id: this.state.patient_id,
            requested_related_party_id:this.state.practitioner_id,
            medicalNotes: doctorNotesData
          }
         //console.log("payload", payload)
          await this.props.saveMedicalNotes(payload);
         
            if (this.props.savedMedicalNotesData.successMessage) {
              //console.log("notes data",this.props.savedMedicalNotesData.savedMedicalNotes)

              let responseData = this.props.savedMedicalNotesData.savedMedicalNotes;

              let attachedDocuments = this.state.attachedDocuments.concat(responseData && responseData.conductAppointmentNotes? [...responseData.conductAppointmentNotes] : [])
                this.setState({
                    isLoading: false,
                    assoRelatedParty: this.state.patient_id,
                    reqProfessional: this.state.practitioner_id,
                    practice_logo: responseData && responseData.practice_logo ? responseData.practice_logo : "",
                    patientDetail: responseData && responseData.patientDetail? {...responseData.patientDetail} : {},
                    practitionerDetail: responseData && responseData.doctorDetail? {...responseData.doctorDetail} : {},
                    attachedDocuments: attachedDocuments,
                    successMsg: this.props.savedMedicalNotesData.successMessage
                })
                this.clearNotes();

              setTimeout(() => {
                this.setState({
                    successMsg: ""
                })
               // history.push("/appoinmentlist");
              }, 3000);
            } else {
            this.setState({
                isLoading: false,
                errorMsg: this.props.savedMedicalNotesData.errorMessage
            })
            setTimeout(() => {
                this.setState({
                    errorMsg: ""
                })
            }, 1000);
          }
    
     }
  };



render() {
    const patientOptions =
    this.props.patientData && this.props.patientData.patient;

    const practitionerOptions =
    this.props.practitionerData && this.props.practitionerData.practitioner;
    
    const externalPractitionersAutoCompData = this.props.externalPractitionersAutoCompData &&
    this.props.externalPractitionersAutoCompData.externalPractitionersAutoComp;

    if (!this.state.isScreenLoaded) {
        return (
          <div className="dashboard-loader">
            <img src={ttmLoader} alt="loader" className="loader-image" />
          </div>
        );
      }

  return (
    <div className={style.medicalNotesWrapper}>
      <div className="row">
        <div className="col-lg-12">
          <h3>Medical Notes</h3>
        </div>
        <div className="col-lg-12 intro-text">
          <p className="mb-4">
          Doctors may create Prescriptions, Referrals Letters and Doctor's Notes by completing the fields below. 
          The contents of the letter/note must be specified in the free-text field provided.
          </p>
        </div>
      </div>
      {/* Create documents section start */}
       <div className="form-box-shadow">
          <div className="row">
              {/* <h6>Create Documents</h6> */}
              <div className="col-sm-6 col-md-6 col-lg-3 mb-3 mb-lg-0">
                  <div className="form-group">
                    <label>
                      Patient Name{" "}
                      <span className="mandatory">
                        <small>*</small>
                      </span>
                    </label>
                    {/* <p>*********** {JSON.stringify(this.state.patient_id)}</p> */}
                    <Select
                      showSearch
                      allowClear={true}
                      name="patient_name"
                      placeholder="Search Patient"
                      optionFilterProp="children"
                      onChange={this.onChangePatient}
                      onSearch={this.onSearchPatient}
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      value={this.state.patient_id || undefined}
                    >
                      {patientOptions &&
                        patientOptions.map((element, index) => (
                          <Option key={index} value={element.patient_id}>
                            {element.patient_name}
                          </Option>
                        ))}
                    </Select>
                  </div>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-3 mb-3 mb-lg-0">
                  <div className="form-group">
                    <label>
                      Practitioner Name{" "}
                      <span className="mandatory">
                        <small>*</small>
                      </span>
                    </label>
                    <Select
                      showSearch
                      allowClear={true}
                      name="practitioner_name"
                      placeholder="Search Practitioner"
                      optionFilterProp="children"
                      onChange={this.onChangePratitioner}
                      onSearch={this.onSearchPratitioner}
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      value={this.state.practitioner_id || undefined}
                    >
                      {practitionerOptions &&
                        practitionerOptions.map((element, index) => (
                          <Option key={index} value={element.practitioner_id}>
                            {element.practitioner_name}
                          </Option>
                        ))}
                    </Select>
                  </div>
                </div>
          </div>
          <div className="row">
            <div className="col-md-3">
              <div className="form-group">
                <label htmlFor="document_type">Type of Documents{" "}
                      <span className="mandatory">
                        <small>*</small>
                      </span></label>
                <select
                  className="form-control"
                  id="document_type"
                  name="document_type"
                  onChange={(e) => this.handleInputChangeTypes(e)}
                  value={this.state.notesTypes}
                >
                  <option value="1">Doctor Note</option>
                  <option value="2">Referral Note</option>
                  <option value="3">Prescription</option>
                </select>
              </div>
            </div>
          </div>
          {this.state.isRefNote && (
            <div className="row">
              <div className="col-lg-3">
                <div className="form-group">
                  {/* <input
                    type="text"
                    className="form-control"
                    id="ref_doctor_name"
                    name="ref_doctor_name"
                    placeholder="Referred doctor name * "
                    value={this.state.ref_doctor_name}
                    onChange={(e) => {
                      this.handleInputRef(e);
                    }}
                    // onBlur={() => handleNotesBlurChange()}
                  /> */}
                  <Select
                    showSearch
                    allowClear={true}
                    name="ref_doctor_name"
                    placeholder="Search Practitioner"
                    optionFilterProp="children"
                    onChange={(value, event) => this.handleInputRefDoctorName(value, "ref_doctor_name")}
                    filterOption={(input, option) =>
                    option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    value={this.state.ref_doctor_id || undefined}
                >
                    {externalPractitionersAutoCompData &&
                    externalPractitionersAutoCompData.map((element, index) => (
                        <Option key={index} value={element.practitioner_id}>
                        {element.practitioner_name}
                        </Option>
                    ))}
                </Select>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="form-group">
                  <input
                    type="text"
                    className={`form-control ${this.state.emailError ? "is-invalid" : ""}`}
                    id="ref_doctor_email"
                    name="ref_doctor_email"
                    placeholder="Referred doctor email * "
                    value={this.state.ref_doctor_email}
                    onChange={(e) => {
                      this.handleInputRef(e);
                    }}
                    // onBlur={() => handleNotesBlurChange()}
                  />
                  {this.state.emailError ? (
                    <span className="error">
                      Please Enter valid email address
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="col-lg-3">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    name="ref_doctor_address"
                    id="ref_doctor_address"
                    placeholder="Referred doctor address * "
                    value={this.state.ref_doctor_address}
                    onChange={(e) => {
                      this.handleInputRef(e);
                    }}
                    // onBlur={() => handleNotesBlurChange()}
                  />
                </div>
              </div>
            </div>
          )}
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <textarea
                  className="form-control"
                  rows={3}
                  id="document_note"
                  name="document_note"
                  placeholder="Enter notes here"
                  onChange={(e) => this.handleInputChangeNotes(e)}
                  // onBlur={() => handleNotesBlurChange()}
                  value={this.state.notesText}
                />
                <span>
                  <small className="error">{this.state.createNoteserror}</small>
                </span>
              </div>
            </div>
          </div>
          <div className="row">
            <div className={`col-md-12 ${style.createNoteWrapper}`}>
              <button
                className="tmed-btn tmed-primary-btn"
                onClick={() => this.noteAdd()}
              >
                {this.state.docTypeBtnLabel}
              </button>
            </div>
          </div>

          {/* <div className="row">
          <div className="col-md-12">
            <p>Notes is: {JSON.stringify(createNotes)}</p>
          </div>
        </div> */}

          <div className="row">
            <div className="col-md-12">
              <ul className={style.notesViewWrapper}>
                {this.state.notesList.map((element, i) => {
                  return (
                    <li key={i}>
                      <div className="row">
                        <div className="col-md-2">
                          <p>
                            {element.notesTypes === "2"
                              ? "Referral Notes"
                              : element.notesTypes === "3"
                              ? "Prescription"
                              : "Doctor Note"}
                          </p>
                        </div>
                        <div className="col-md-8 d-flex">
                          {element.notesText && (
                          <div className="mr-3 text-align-justify">
                            <p>{element.notesText}</p>
                          </div>)}

                          {element.ref_doctor_name && (
                          <div className={`mr-3 ${style.borderLeft}`}>
                            <p>{element.ref_doctor_name}</p>
                          </div>)}

                        {element.ref_doctor_email && ( 
                        <div className={`mr-3 ${style.borderLeft}`}>
                            <p className={style.emailText}>
                              {element.ref_doctor_email}
                            </p>
                          </div>)}

                          {element.ref_doctor_address && (
                          <div className={`mr-3 ${style.borderLeft}`}>
                            <p>{element.ref_doctor_address}</p>
                          </div>)}
                        </div>
                        <div className="col-md-1 justify-content-md-end">
                          <i
                            className={`fa fa-pencil-square-o ${style.editIcon}`}
                            onClick={() => this.onEditClick(i, element.notesTypes)}
                          ></i>
                        </div>
                        <div className="col-md-1 justify-content-md-end">
                          <i
                            className={`fa fa-times ${style.removeIcon}`}
                            onClick={() => this.handleRemoveNoteClick(i)}
                          ></i>
                        </div>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
      
      {/* Create documents section end */}

      <div className="row">
        <div className="col-md-12">
          {this.state.isError && (
            <div className={`error ${style.errorText}`}>{this.state.isError}</div>
          )}
        </div>
      </div>

      {this.state.attachedDocuments && this.state.attachedDocuments.length > 0 && (
      <div className="form-box-shadow mt-4">
        <div className="row">
          <div className="col-lg-12">
            <h4>Attached Documents</h4>
            <AppointmentNotesSection data={this.state} />
          </div>
        </div>
      </div>)}

      <div className={`row ${style.saveBtnWrapper}`}>
        <div className="col-md-12">
          <div>
            {/* <Button className="ttm-primary-btn mr-2">Create Invoice</Button> */}
            <Button
              className="ttm-primary-btn"
              type="button"
              onClick={this.onSubmit}
            >
              Save
            </Button>
          </div>
        </div>
      </div>

      <div className="row ">
        <div className="col-md-12">
          {this.state.isLoading ? (
            <div className={`error ${style.loadingWrapper}`}>
              <img src={ttmLoader} alt="loader" className={style.loading} />
            </div>
          ) : (
            <div>
              {this.state.successMsg && (
                <p className={style.successMessage}>{this.state.successMsg}</p>
              )}
              {this.state.errorMsg && <p className={style.errorMessage}>{this.state.errorMsg}</p>}
            </div>
          )}
        </div>
      </div>

    </div>
  );
    }
}

//export default MedicalNotes;

const mapStateToProps = (state) => {
    return {
      practitionerData: state.practitioner,
      patientData: state.patient,
      savedMedicalNotesData: state.savedMedicalNotes,
      externalPractitionersAutoCompData: state.externalPractitionersAutoComp
    };
  };
  
  const mapDispatchToProps = (dispatch) => {
    return {
      fetchpractitioner: (practitionerName) =>
        dispatch(fetchpractitioner(practitionerName)),
      fetchpatient: (patientName) => dispatch(fetchpatient(patientName)),
      saveMedicalNotes: (payload)=> dispatch(saveMedicalNotes(payload)),
      fetchExternalPractitionerAutoComp: (practitionerName)=> dispatch(fetchExternalPractitionerAutoComp(practitionerName, 1)), 
    };
  };
  
  export default connect(mapStateToProps, mapDispatchToProps)(MedicalNotes);
  